import axios from 'axios';
import i18n from '../plugins/i18n';
import router from '../router'; // eslint-disable-line

const baseDomain = process.env.VUE_APP_API_PATH;
const baseURL = `${baseDomain}`;


const apiClient = axios.create({
  baseURL,
  // headers : { Authorization: msaltoken }
});

apiClient.interceptors.response.use(response => response, (error) => {
  if (error.response.status === 401) {
    router.replace({ name: 'authentication-error', params: { lang: i18n.locale } });
  }
  Promise.reject(error.message);
});


export default apiClient;

export function setApiClientAuthorization(accessToken) {
  // TODO: should probably pass access token in implicit flow, but backend will
  // probably assume a valid (jwt) ID token instead
  apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}
